import * as m from '~/paraglide/messages'
import { createFieldValidators } from '~/shared/lib/form-utils'
import { updateLocationSchema } from '~/shared/types'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/shared/ui/card'
import { CountrySelect } from '~/shared/ui/country-select'
import { FormField, FormInput } from '~/shared/ui/form'

interface LocationSectionProps {
  // biome-ignore lint/suspicious/noExplicitAny: TanStack Form API is dynamically typed
  form: any
}

export function LocationSection({ form }: LocationSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{m.location()}</CardTitle>
        <CardDescription>{m.updateYourBusinessAddress()}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <form.Field
          name="street"
          validators={createFieldValidators(updateLocationSchema.shape.street)}
        >
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => (
            <FormInput
              field={field}
              label={m.streetAddress()}
              placeholder={m.addressPlaceholder()}
            />
          )}
        </form.Field>

        <div className="gap-4 grid grid-cols-1 xs:grid-cols-2">
          <form.Field
            name="city"
            validators={createFieldValidators(updateLocationSchema.shape.city)}
          >
            {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
            {(field: any) => <FormInput field={field} label={m.city()} />}
          </form.Field>

          <form.Field
            name="country"
            validators={createFieldValidators(updateLocationSchema.shape.country)}
          >
            {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
            {(field: any) => (
              <FormField field={field} label={m.country()}>
                <CountrySelect
                  id={field.name}
                  name={field.name}
                  value={field.state.value || ''}
                  onBlur={field.handleBlur}
                  onChange={field.handleChange}
                  placeholder={m.selectACountry()}
                />
              </FormField>
            )}
          </form.Field>
        </div>
      </CardContent>
    </Card>
  )
}
